// 根据新的菜单结构配置
const menuData = [
	{
		name: '首页',
		icon: 'menu-home',
		module: 'home',
		url: '/home/index',
	},
	{
		name: '产品选型',
		icon: 'menu-purchase',
		module: 'productSelection',
		children: [
			{
				name: '产品选型',
				children: [
					{
						name: 'AI选型',
						url: '',
					},
					{
						name: '产品选型',
						url: '/purchase/product',
					},
					{
						name: '专业选型',
						url: '/purchase/index',
					}
				]
			}
		]
	},
	{
		name: '市场大厅',
		icon: 'menu-market',
		module: 'market',
		children: [
			{
				name: '市场大厅',
				children: [
					{
						name: '销售中心',
						url: '/saleMessage/index',
					},
					{
						name: '采购中心',
						url: '/supplierMessage/index',
					}
				]
			}
		]
	},
	{
		name: '我要采购',
		icon: 'menu-purchase',
		module: 'purchase',
		children: [
			{
				name: '我要采购',
				children: [
					{
						name: '新增询价单',
						url: '/purchase/addInquiryPage',
					},
					{
						name: '我的询价',
						url: '/purchase/enquiry'
					},
					{
						name: '供应商报价',
						url: '/purchase/supplierQuotation'
					},
					{
						name: '我的采购',
						url: '/purchase/mypurchase'
					}
				]
			}
		]
	},
	{
		name: '我要销售',
		icon: 'menu-sale',
		module: 'mysale',
		showFlag: true,
		children: [
			{
				name: '我要销售',
				children: [
					{
						name: '销售中心',
						url: '/mysale/orderSetup'
					},
					{
						name: '新增报价单',
						url: '/mysale/addOfferOrder'
					},
					{
						name: '客户询价',
						url: '/mysale/customerInquiry',
					},
					{
						name: '我的报价',
						url: '/mysale/customerOffer',
					},
					{
						name: '我的订单',
						url: '/mysale/order'
					},
					{
						name: '订单作废',
						url: '/mysale/orderUndo'
					},
					{
						name: '资金列表',
						url: '/mysale/capitalList'
					},
					{
						name: '发票申请',
						url: '/mysale/invoice'
					}
				]
			}
		]
	},
	{
		name: '客户',
		icon: 'menu-client',
		module: 'client',
		showFlag: true,
		children: [
			{
				name: '客户',
				children: [
					{
						name: '我的客户',
						url: '/client/index',
					},
					{
						name: '地区客户',
						url: '',
					},
					{
						name: '全国客户',
						url: '',
					}
				]
			}
		]
	},
	{
		name: '供应商',
		icon: 'menu-supplier',
		module: 'supplier',
		children: [
			{
				name: '供应商',
				children: [
					{
						name: '我的供应商',
						url: '/supplier/index',
					},
					{
						name: '查找供应商',
						url: '/supplier/find',
					}
				]
			}
		]
	},
	{
		name: '盘查CRM',
		icon: 'menu-stock',
		module: 'stock',
		showFlag: true,
		children: [
			{
				name: '盘查CRM/实时库存',
				children: [
					{
						name: '查看公司库存',
						url: '/stock/index',
					},
					{
						name: '停滞仓库',
						url: '',
					},
					{
						name: '订单同步',
						url: '',
					},
					{
						name: '入库明细',
						url: '/stock/enterStock',
					},
					{
						name: '出库明细',
						url: '/stock/outStock',
					}
				]
			}
		]
	},
	{
		name: '账号管理',
		icon: 'menu-account',
		module: 'system',
		children: [
			{
				name: '账号管理',
				children: [
					// 基本信息
					// {
					// 	name: '基本信息',
					// 	url: '/myMessage'
					// },
					{
						name: '企业信息',
						url: '/companyInfo'
					},
					// {
					// 	name: '安全中心',
					// 	url: '/system/index'
					// },
					{
						name: '个人中心',
						url: '/personal/index'
					},
				]
			}
		]
	}
];

export default menuData;
